// A deploy replaces the hashed /_next/static chunks; a tab opened before
// the deploy can then lazy-load a chunk that no longer exists and crash
// into the route error boundary. Those errors are cured by one reload,
// which picks up the new build manifest.
export function isStaleChunkError(
  error: { name?: string; message?: string } | null | undefined
): boolean {
  if (!error) return false;
  if (error.name === 'ChunkLoadError') return true;
  // Turbopack ("Failed to load chunk ... from module ...") and webpack
  // ("Loading chunk N failed" / "Loading CSS chunk N failed") wordings.
  return /Failed to load chunk|Loading (?:CSS )?chunk \S+ failed/i.test(error.message || '');
}
